/** @format */

import ApiCollectionResponseInterface from '../../interfaces/api/ApiCollectionResponseInterface';
import MvnoBlockFunction from '../../interfaces/platform/MvnoBlockFunction';
import MvnoBlockContain from '../../interfaces/platform/MvnoBlockContain';
import MvnoBlockRequestState from '../../interfaces/platform/MvnoBlockRequestState';
import MvnoBlockRequest from '../../interfaces/platform/MvnoBlockRequest';

const _ = require('underscore');

export interface MvnoBlockFunctionsCollection extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockFunction> | null;
}

export interface GetContainViewProps {
    functions: MvnoBlockFunctionsCollection;
    element: MvnoBlockContain;
    classes: any;
}

export interface GetBlockStateViewProps {
    dispatch: any;
    mvnoBlockRequest: MvnoBlockRequest;
    blockFunction: MvnoBlockFunction;
    stateBlock: MvnoBlockRequestState;
    classes: any;

    viewDialog(title: any | string | null, content: any | null): void;
}

export interface StatusField {
    call: string;
    value: string;
}

export interface CallBlock {
    blockId: number;
    params: Array<any>;
}

export interface FieldsCondition {
    msisdn: string;
    callNext: string | null;
    callOnError: string | null;
    callBlock: CallBlock | null;
    status: Array<StatusField> | number | string | null;
}

export class BlockContainHelper {
    getFunctionNameById = (id: number, functionsCollection: MvnoBlockFunctionsCollection): string | null => {
        const functionList = functionsCollection['hydra:member'];
        let name: string | null = null;
        if (functionList !== null) {
            functionList.map((f: MvnoBlockFunction) => {
                if (id === f.id) {
                    name = 'prov:f.' + f.displayName.trim().toLowerCase();
                }
            });
        }
        return name;
    };

    explodeParams = (element: MvnoBlockContain): FieldsCondition => {
        return this.getParams(element.conditions);
    };

    getParams = (params: string): FieldsCondition => {
        return JSON.parse(params) as FieldsCondition;
    };
}
